export default __webpack_public_path__ + "static/media/hand-shake.2d35fc05.svg";